var cifCg = ["301 201", "<g fill='none'><path fill='#009543' d='M.5.5h300v200H.5z'/><path fill='#FBDE4A' d='M.5 200.5l200-200h100v200z'/><path fill='#DC241F' d='M300.5.5v200h-200z'/></g>"];

export { cifCg };

